import axios from "axios";
import { configAxiosApp } from "./config";

const AxiosManager = axios.create({
  baseURL: `${configAxiosApp.v02}/manager`,
});




AxiosManager.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  const token = localStorage.getItem("accessToken");

  if (token && 401 === error.response.status) {


    localStorage.removeItem("accessToken");
    localStorage.removeItem("umname");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("UseData");
    window.location = '/';
    // return Promise.reject(error);

  } else {
    return Promise.reject(error);
  }
});

export default AxiosManager;
